export default function reducer(state = {
  formatos: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_FORMATOS": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}